import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDirectoryIcon = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 99.562,
	height: 92.25,
	fill: "none",
	viewBox: "0 0 99.562 92.25",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-201.75 -9)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m292.88 27.882v2.4926h-70.837c-3.294-0.0053-6.137 5.1327-6.796 8.0023l-2.071 9.0137-10.385 45.195c-0.697 3.0309 1.221 5.9075 4.233 6.9716 6e-3 0 7e-3 0.0034 0.013 0.0052l-0.351-0.0035s-0.01-0.0035-0.013-0.0053c-2.887-1.1429-4.918-3.8775-4.918-7.0679v-64.603c0-4.2141 3.549-7.6324 7.925-7.6324h75.268c4.381 0 7.93 3.4183 7.93 7.6324z",
				fill: "#002e5f"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m214.38 11.715v70.526c0 1.4998 1.215 2.7148 2.715 2.7148h50.611c1.5 0 2.719-1.215 2.719-2.7148v-70.526c0-1.4997-1.219-2.7147-2.719-2.7147h-50.611c-1.5 0-2.715 1.215-2.715 2.7147z",
				fill: "#acd4ff"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m301.17 42.866-0.388 1.6996-10.57 46.245-0.498 2.1738-0.572 2.5095-0.204 0.8931c-0.4 1.7618-1.632 3.2156-3.285 4.0623-0.834 0.427-1.776 0.699-2.771 0.777h-0.01c-0.199 0.015-0.401 0.024-0.604 0.024h-0.465l-1.093-3e-3h-1.09l-73.561-0.539c-0.047-0.017-0.079-0.029-0.111-0.041-0.157-0.057-0.309-0.12-0.459-0.189-0.07-0.031-0.139-0.064-0.205-0.097-0.013-7e-3 -0.025-0.01-0.036-0.017-0.065-0.031-0.127-0.064-0.188-0.097-0.055-0.031-0.112-0.061-0.168-0.094-0.048-0.027-0.096-0.053-0.141-0.084-0.091-0.054-0.18-0.1111-0.266-0.1699-0.054-0.0329-0.104-0.0693-0.154-0.1056-0.012-0.0104-0.028-0.019-0.041-0.0294-0.052-0.0364-0.1-0.0727-0.15-0.1125-0.014-0.0104-0.03-0.0225-0.044-0.0329-0.042-0.0329-0.083-0.0658-0.124-0.1004-0.144-0.1159-0.284-0.2406-0.416-0.3704-0.039-0.038-0.077-0.0761-0.116-0.1142-0.07-0.0692-0.136-0.1384-0.198-0.2111-0.052-0.0571-0.102-0.116-0.15-0.1766-0.045-0.0519-0.088-0.1055-0.129-0.1592-0.011-0.0104-0.018-0.0208-0.025-0.0312-0.045-0.0588-0.088-0.1176-0.13-0.1782-0.045-0.0623-0.09-0.1264-0.131-0.1921-0.039-0.0589-0.075-0.1177-0.114-0.1783-6e-3 -0.0086-0.011-0.0138-0.013-0.0225-0.037-0.064-0.075-0.1298-0.11-0.1938-0.036-0.0693-0.074-0.135-0.106-0.2043-0.034-0.0692-0.068-0.1367-0.098-0.2076-0.032-0.071-0.061-0.1402-0.089-0.2112-0.172-0.4275-0.292-0.8723-0.351-1.3326v-0.0104c-0.08-0.6214-0.053-1.2686 0.097-1.9229l10.195-44.622 2.035-8.8993c0.1-0.4414 0.253-0.8654 0.452-1.2617 0.318-0.637 0.754-1.215 1.281-1.7083 0.414-0.3894 0.882-0.7286 1.395-1.0055 0.139-0.0779 0.28-0.1489 0.425-0.2164 0.257-0.1177 0.522-0.2215 0.793-0.308 0.729-0.2389 1.511-0.3652 2.322-0.3635l15.791 0.026 13.491 0.0225 44.45 0.0744c0.484 0 0.95 0.0485 1.402 0.1315 3.566 0.6767 6.011 3.8319 5.25 7.1773z",
				fill: "#006adc"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 220.38,
				y: 15,
				width: 35,
				height: 4,
				rx: 2,
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 220.38,
				y: 25,
				width: 45,
				height: 4,
				rx: 2,
				fill: "#fff"
			})
		]
	})
});
const ForwardRef = forwardRef(SvgDirectoryIcon);
export default ForwardRef;
